import {
  axiosGetWithCookies,
  axiosPutWithCookies,
  axiosPatchWithCookies,
  axiosDeleteWithCookies,
} from './helper';
import { startOfDay, endOfDay } from 'utils/time';

export const fetchAttendanceList = ({
  from,
  limit = 50,
  personnel,
  shiftStatus,
  fromDate,
  toDate,
  search,
  timezone,
  departmentId,
  securityCompanyId,
}) => {
  let query = `/users/attendance/shifts?limit=${limit}`;
  if (from) query += `&from=${from}`;
  if (personnel) {
    query += `&userId=${personnel}`;
  }
  if (departmentId === 'EMPTY_VALUE') {
    query += `&departmentId=${'EMPTY_VALUE'}`;
  } else if (departmentId) {
    query += `&departmentId=${departmentId}`;
  }
  if (Array.isArray(shiftStatus)) {
    /* eslint-disable no-param-reassign */
    query += shiftStatus.reduce((acc, c) => {
      if (c?.multiOptions) {
        c.multiOptions.forEach(option => {
          acc += `&status=${option}`;
        });
        return acc;
      } else return (acc += `&status=${c.id}`);
    }, '');
  }
  if (fromDate) {
    const startFrom = startOfDay({
      date: fromDate,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (toDate) {
    const endAt = endOfDay({
      date: toDate,
      timezone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (securityCompanyId) {
    query += `&securityCompanyId=${securityCompanyId}`;
  }
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};

export const fetchShiftById = ({ id }) => {
  return axiosGetWithCookies(`/users/attendance/shifts/${id}`);
};

export const fetchAttendanceTrackingListCSV = ({
  from,
  limit = 100,
  personnel,
  shiftStatus,
  fromDate,
  toDate,
  search,
  timezone,
}) => {
  let query = `/users/attendance/shifts/csv?limit=${limit}&timezone=${timezone}`;
  if (from) query += `&from=${from}`;
  if (personnel) {
    query += `&userId=${personnel}`;
  }
  if (Array.isArray(shiftStatus)) {
    query += shiftStatus.reduce((acc, c) => {
      if (c?.multiOptions) {
        c.multiOptions.forEach(option => {
          acc += `&activityType=${option}`;
        });
        return acc;
      } else return (acc += `&activityType=${c.id}`);
    }, '');
  }
  if (fromDate) {
    const startFrom = startOfDay({
      date: fromDate,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (toDate) {
    const endAt = endOfDay({
      date: toDate,
      timezone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (search) query += `&search=${search}`;
  return axiosGetWithCookies(query);
};

export const fetchAttendanceTrackingListPDF = ({
  from,
  limit = 100,
  personnel,
  shiftStatus,
  fromDate,
  toDate,
  search,
  timezone,
  language,
}) => {
  let query = `/users/attendance/shifts/pdf?limit=${limit}&timezone=${timezone}`;
  if (from) query += `&from=${from}`;
  if (personnel) {
    query += `&userId=${personnel}`;
  }
  if (Array.isArray(shiftStatus)) {
    query += shiftStatus.reduce((acc, c) => {
      if (c?.multiOptions) {
        c.multiOptions.forEach(option => {
          acc += `&activityType=${option}`;
        });
        return acc;
      } else return (acc += `&activityType=${c.id}`);
    }, '');
  }
  if (fromDate) {
    const startFrom = startOfDay({
      date: fromDate,
      timezone: timezone || 'UTC',
    });
    query += `&fromDate=${startFrom}`;
  }
  if (toDate) {
    const endAt = endOfDay({
      date: toDate,
      timezone: timezone || 'UTC',
    });
    query += `&toDate=${endAt}`;
  }
  if (search) query += `&search=${search}`;
  if (language) query += `&language=${language}`;
  return axiosGetWithCookies(query);
};

export const createShift = ({ shift }) => {
  const query = '/users/attendance/shifts';
  return axiosPutWithCookies(query, { data: shift });
};

export const updateShift = ({ shiftActivity, oldShiftActivityId }) => {
  const query = `/users/attendance/shift-activities/${oldShiftActivityId}`;
  return axiosPatchWithCookies(query, { data: shiftActivity });
};

export const deleteShift = ({ shiftId }) => {
  const query = `/users/attendance/shift-activities/${shiftId}`;
  return axiosDeleteWithCookies(query);
};
